import { useMemo } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import {
  setCardslistLoading,
  setNavigationCluster,
  setScrollApplied,
} from "redux/SingleDataset/actions";
import {
  DATA_PAGE_PARAMETER,
  PAGE_PARAMETER,
  VERTEX_ID,
} from "helpers/constants/miscellaneous";
import styles from "./style.module.scss";
import BaseButton from "views/atomComponents/Buttons/BaseButton";
import TooltipWrapper from "views/uikit/TooltipWrapper";
import ContentLoad from "views/uikit/ContentLoad";
import XIcon from "assets/icons/XIcon";
import { State } from "redux/store";
import {
  getNavigationCluster,
  getNavigationClusterLoader,
  getTotalPagesForCluster,
} from "redux/SingleDataset/selectors";

export interface ClusterLabel {
  text: string;
  onClick: () => void;
  tooltip: string;
}
interface ClusterDetailsFilterProps {
  navigationCluster: any;
  navigationClusterLoader: boolean;
  label?: ClusterLabel;
}
const ClusterDetailsFilter = ({
  navigationCluster,
  navigationClusterLoader,
  label,
}: ClusterDetailsFilterProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );
  const clusterType = navigationCluster?.type === "IMAGES" ? "Image" : "Object";
  const clusterDisplayID = navigationCluster?.cluster_id.substring(0, 8);

  const formattedTitle = navigationCluster
    ? `${clusterType} Cluster #${clusterDisplayID}`
    : "Cluster ";

  const handleRemoveFilter = async () => {
    dispatch(setCardslistLoading(true));

    const path = `${location.pathname.split("/cluster")[0]}`;

    // Always ensure page parameter is set to maintain consistency
    if (!searchParams.has(VERTEX_ID)) {
      if (searchParams.has(DATA_PAGE_PARAMETER)) {
        const dataPageNumber = searchParams.get(DATA_PAGE_PARAMETER);
        if (dataPageNumber != null) {
          searchParams.set(PAGE_PARAMETER, dataPageNumber);
        }
        searchParams.delete(DATA_PAGE_PARAMETER);
      } else {
        // Set page to 1 if not already present
        searchParams.set(PAGE_PARAMETER, "1");
      }
    } else {
      searchParams.set(PAGE_PARAMETER, "1");
      searchParams.delete(DATA_PAGE_PARAMETER);
    }

    const newSearchParams = "?" + searchParams.toString();

    const pathWithParams = path.concat(newSearchParams);
    dispatch(setScrollApplied(false));
    navigate(pathWithParams);
    dispatch(setNavigationCluster(null));
  };

  const renderButtonLabel = () => {
    if (navigationClusterLoader) {
      return (
        <div className={styles.navigationClusterTitleLoader}>
          <ContentLoad />
        </div>
      );
    } else {
      return formattedTitle;
    }
  };

  const tooltipId = "data-page-cluster-details-filter-box";

  return (
    <div
      data-tooltip-content={
        label?.tooltip || `Remove filter to go back to Dataset.`
      }
      data-tooltip-id={tooltipId}
    >
      <BaseButton
        variant="selected"
        label={label?.text || renderButtonLabel()}
        onClick={label?.onClick || handleRemoveFilter}
        iconRight={<XIcon variant="new" />}
      />
      <TooltipWrapper id={tooltipId} />
    </div>
  );
};

const mapStateToProps = (state: State) => {
  return {
    navigationCluster: getNavigationCluster(state),
    navigationClusterLoader:
      getNavigationClusterLoader(state) || !getTotalPagesForCluster(state),
  };
};

export default connect(mapStateToProps)(ClusterDetailsFilter);
